import api from '../config/api';

import {
  setSessionToken,
  getSessionToken,
  removeSessionToken,
  setSessionExpiry,
  getSessionExpiry,
  removeSessionExpiry
} from './LocalStorageService';

const EXPIRY_MS = 60 * 60 * 1000; // 1 hour client-side session expiry

const applyAuthHeader = token => api.setHeader('Authorization', `Bearer ${token}`);

export const setCurrentUser = token => {
  applyAuthHeader(token);
  setSessionToken(token);
  setSessionExpiry(Date.now() + EXPIRY_MS);
};

export const removeCurrentUser = () => {
  removeSessionToken();
  removeSessionExpiry();
  api.deleteHeader('Authorization');
};

export const getCurrentUser = () => {
  const token = getSessionToken();
  const expiresAt = getSessionExpiry();

  if (!token || !expiresAt || Date.now() > expiresAt) {
    removeCurrentUser();

    return false;
  }

  applyAuthHeader(token);

  return true;
};

export const login = async (username, password) => {
  const response = await api.post('/auth/sign_in', { username, password });

  if (response.ok && response.data && response.data.token) {
    setCurrentUser(response.data.token);

    return { ok: true };
  }

  return { ok: false };
};
